export default __webpack_public_path__ + "media/images/icons_fc/group2-6634b24f1d1725f05387d05ea9a55f12.png";